import dayjs from 'dayjs'
import constants from 'config/constants'
import useAxios from 'hooks/useAxios'
import store from 'store'

function useUser() {
  const timezone = dayjs.tz.guess()

  const { data: currentUser } = useAxios({
    url: `account/users/me/v2/?timezone=${encodeURIComponent(timezone)}`,
    key: store.get(constants.simplesatWorkspaceTokenName),
  })
  const currentTimezone = currentUser?.selected_workspace?.timezone || 'default'
  const currentTimezoneLabel = currentUser?.selected_workspace?.timezone_label || 'Local Timezone'

  const localStorageTimezone = store.get(constants.simplesatWorkspaceTimezone)
  if (
    currentTimezone !== localStorageTimezone?.value ||
    currentTimezoneLabel !== localStorageTimezone?.label
  ) {
    store.set(constants.simplesatWorkspaceTimezone, {
      value: currentTimezone,
      label: currentUser?.selected_workspace?.timezone_label || 'default',
    })
  }

  const currentWeekStartDay = currentUser?.selected_workspace?.week_start_day || 'monday'
  const localStorageWeekStartDay = store.get(constants.simplesatWorkspaceWeekStartDay)
  if (currentWeekStartDay !== localStorageWeekStartDay) {
    store.set(constants.simplesatWorkspaceWeekStartDay, currentWeekStartDay)
  }

  return currentUser
}

export default useUser



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/hooks/useUser/index.js